export const PLACEMENTS_ROUTE = {
  name: 'Placements',
  path: 'placements',
};
